<template>
  <div class="global-header-wrapper">
    <div class="global-header">
      <section class="logo-and-nav-wrapper">
        <section class="logo-wrapper">
          <img src="../assets/logo-white.png" alt />
          <!-- <div class="divider"></div> -->
          <span class="text-span">授权系统</span>
        </section>
      </section>

      <section class="logo-and-nav-wrapper">
        <a-menu v-model="currentMenu" mode="horizontal" theme="dark" :subMenuCloseDelay="0">
          <a-sub-menu v-action="['admin', 'producer']">
            <span slot="title">设备管理</span>
            <a-menu-item key="device-query" @click="$router.push({name:'device-query'})">查询设备</a-menu-item>
          </a-sub-menu>

          <a-sub-menu v-action="['admin']">
            <span slot="title">生产者管理</span>
            <a-menu-item key="producer-query" @click="$router.push({name:'producer-query'})">查询生产者</a-menu-item>
            <a-menu-item key="producer-add" @click="$router.push({name:'producer-add'})">添加生产者</a-menu-item>
          </a-sub-menu>

          <a-sub-menu v-action="['admin', 'producer']">
            <span slot="title">产品管理</span>
            <a-menu-item key="product-query" @click="$router.push({name:'product-query'})">查询产品</a-menu-item>
            <a-menu-item v-action="['admin']" key="product-add" @click="$router.push({name:'product-add'})">添加产品</a-menu-item>
          </a-sub-menu>

          <a-sub-menu v-action="['admin', 'vip', 'finance']">
            <span slot="title">订单与发票管理</span>
            <a-menu-item v-action="['admin', 'vip']" key="order" @click="$router.push({name:'order'})">查询订单</a-menu-item>
            <a-menu-item v-action="['vip']" key="invoice" @click="$router.push({name:'invoice'})">查询发票</a-menu-item>
            <a-menu-item v-action="['admin', 'finance']" key="invoiceList" @click="$router.push({name:'invoiceList'})">发票列表</a-menu-item>
            <a-menu-item v-action="['admin', 'finance']" key="invoiceVerify" @click="$router.push({name:'invoiceVerify'})">发票信息审核</a-menu-item>
            <a-menu-item v-action="['admin']" key="authCode" @click="$router.push({name:'authCode'})">兑换码</a-menu-item>
            <a-menu-item v-action="['admin']" key="device-list" @click="$router.push({name:'device-list'})">设备列表</a-menu-item>
          </a-sub-menu>

          <a-sub-menu v-action="['admin']">
            <span slot="title">功能管理</span>
            <a-menu-item key="func-query" @click="$router.push({name:'func-query'})">查询功能</a-menu-item>
            <a-menu-item key="func-add" @click="$router.push({name:'func-add'})">添加功能</a-menu-item>
          </a-sub-menu>

          <a-sub-menu v-action="['admin']">
            <span slot="title">授权码管理</span>
            <a-menu-item key="hardware-bind" @click="$router.push({name:'hardware-bind'})">绑定硬件</a-menu-item>
            <a-menu-item key="hardware-unbind" @click="$router.push({name:'hardware-unbind'})">解绑硬件</a-menu-item>
            <a-menu-item key="query-auth-history" @click="$router.push({name:'query-auth-history'})">查询授权历史</a-menu-item>
            <a-menu-item key="query-auth-pre" @click="$router.push({name:'query-auth-pre'})">查询预授权</a-menu-item>
          </a-sub-menu>

          <a-sub-menu v-action="['admin']">
            <span slot="title">微信openid管理</span>
            <a-menu-item key="openid-query" @click="$router.push({name:'openid-query'})">查询openid</a-menu-item>
            <a-menu-item key="openid-add" @click="$router.push({name:'openid-add'})">添加openid</a-menu-item>
            <a-menu-item key="openid-get" @click="$router.push({name:'openid-get'})">扫码获取openid</a-menu-item>
          </a-sub-menu>

          <a-sub-menu class="user-sub-menu">
            <span slot="title">
              <div class="cant-select">
                <a-avatar icon="user" />
                <span style="color:white;margin-left:8px;">{{userName}}</span>
              </div>
            </span>
            <a-menu-item v-action="['admin']" key="password-modify" @click="$router.push({name:'password-modify'})">修改密码</a-menu-item>
            <a-menu-item key="logoutKey" @click="handleLogout">退出登录</a-menu-item>
          </a-sub-menu>
        </a-menu>
      </section>
    </div>
  </div>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'global-header',

  data() {
    return {
      currentMenu: this.$route.name.split()
    }
  },

  computed: {
    ...mapGetters(['userName', 'password', 'role'])
  },

  methods: {
    ...mapActions(['Logout']),

    handleLogout() {
      this.$confirm({
        title: '确定退出登录吗？',
        onOk: () => {
          return this.Logout({}).then(() => {
            window.location.reload()
          })
        }
      })
    }
  }
}
</script>


<style lang='less' scoped >
.user-sub-menu {
  /deep/ .ant-menu-submenu-title {
    padding: 0px 0px 0px 20px;
  }
}

/deep/ .ant-menu-horizontal {
  text-align: center;
  line-height: 64px;
  font-size: 16px; //菜单字体
}
/deep/ .anticon-user {
  margin-right: 0px;
  transform: translateY(-2px);
}
.global-header-wrapper {
  background: #001529;
  position: sticky;
  top: 0;
  z-index: 1000;
  .global-header {
    width: 1300px;
    margin: 0 auto;
    height: 64px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: white;

    section.logo-and-nav-wrapper {
      display: flex;
      .logo-wrapper {
        height: 64px;
        display: flex;
        align-items: center;
        font-size: 24px; //logo字体
        font-weight: bold;

        img {
          height: 24px;
          transform: translateY(1px);
          margin-right: 16px;
        }
        .divider {
          height: 34px;
          width: 1px;
          background: white;
          margin: 0 24px;
        }
      }
    }
  }
}
</style>